import produce from "immer";
import * as CalAssaySummConstant from './CalAssaySummConstants';

const assign = Object.assign || require('object.assign');

export default function CalAssaySummReducer(state = {}, action) {

    switch (action.type) {

        case  CalAssaySummConstant.CAL_ASSAY_STATE_ADD: {
            const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isCalAssaySummFetched: false,
                    isCalAssaySummFetching: false,
                    isCalAssaySummFailed: false,
                    calAssaySummData: []
                    
                }
            });
            return assign({}, state, newState);
        }

        case CalAssaySummConstant.CAL_ASSAY_STATE_REMOVE: {
            const newState = produce(state, (draft) => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
            });
            return assign({}, newState);
        }

        case CalAssaySummConstant.CAL_ASSAY_SUMMARY_DATA_FETCHING:{
           
            const newState = produce(state, (draft) => {
                
                draft[action.payload] = {
                    ...draft[action.payload],
                    isCalAssaySummFetched: false,
                    isCalAssaySummFetching: true,
                    isCalAssaySummFailed: false,
                    calAssaySummData: []
                }
                
            });
            return assign({}, state,newState);
        }
        
        case CalAssaySummConstant.CAL_ASSAY_SUMMARY_DATA_FETCHED:{
            
            const newState = produce(state, (draft) => {
                draft[action.payload.deviceId] = {
                    ...draft[action.payload.deviceId],
                    isCalAssaySummFetched: true,
                    isCalAssaySummFetching: false,
                    isCalAssaySummFailed: false,
                    calAssaySummData: action.payload.newState.result
                }
            });

            return assign({}, state,newState);
        }

        case CalAssaySummConstant.CAL_ASSAY_SUMMARY_DATA_FETCHING_FAILED:{
           const newState = produce(state, (draft) => {
                draft[action.payload] = {
                    ...draft[action.payload],
                    isCalAssaySummFetched: false,
                    isCalAssaySummFetching: false,
                    isCalAssaySummFailed: true,
                    calAssaySummData: []
                }
            });

            return assign({}, state,newState);
        }
        
        default:
        return state;

    }
}
